export default __webpack_public_path__ + "static/star_background-9c3243be5de365ee35529d94919dab74.jpeg";